<ng-content
  *ngIf="!(isLoading | async) else loader"></ng-content>
<ng-template #loader>
  <div class="loader">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>